var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.043,4.892A15.522,15.522,0,0,0,2.618,23.617l-2.2,8.042L8.643,29.5a15.512,15.512,0,0,0,7.416,1.889h.006a15.526,15.526,0,0,0,10.978-26.5ZM16.065,28.769H16.06a12.882,12.882,0,0,1-6.565-1.8l-.471-.28L4.142,27.972l1.3-4.76-.307-.488a12.9,12.9,0,1,1,10.927,6.045Zm7.075-9.661c-.387-.194-2.294-1.132-2.649-1.261s-.614-.194-.873.194-1,1.262-1.228,1.52-.452.292-.84.1a10.591,10.591,0,0,1-3.118-1.924,11.672,11.672,0,0,1-2.157-2.686c-.226-.389,0-.578.17-.792a10.861,10.861,0,0,0,.969-1.326.711.711,0,0,0-.032-.679c-.1-.194-.872-2.1-1.2-2.88-.315-.755-.635-.653-.873-.665s-.485-.014-.743-.014a1.421,1.421,0,0,0-1.034.486A4.345,4.345,0,0,0,8.18,12.412a7.545,7.545,0,0,0,1.583,4.012c.194.258,2.734,4.175,6.624,5.854A21.91,21.91,0,0,0,18.6,23.1a5.3,5.3,0,0,0,2.442.154,3.991,3.991,0,0,0,2.617-1.844,3.242,3.242,0,0,0,.226-1.844C23.787,19.4,23.528,19.3,23.14,19.108Z",
    fill: "#596975",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.0560d89ae3f148fff5b4eb6dd6bae2a9.svg";
export { ForwardRef as ReactComponent };